import React, { useEffect } from "react";
import { useState } from "react";
import ReactApexChart from "react-apexcharts";
import { formatToIndianNumber, getYearsOptions } from "../../../utilities";
import GlobalSearchableDropdown from "../../Constant/SearchableDropdown";
import { getRevenueLossDashboardApi } from "../../../services/DashboardService";
import { toast } from "react-toastify";
const ProfitLossLineChart = ({ selectedServicecenter }) => {
  const [yearOption, setYearOption] = useState(getYearsOptions);
  const [selectdeYear, setSelectedYear] = useState(yearOption[0]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const getData = () => {
    setLoading(true);
    getRevenueLossDashboardApi(
      selectedServicecenter == "all" ? "" : selectedServicecenter,
      selectdeYear?.value
    )
      .then((res) => {
        setData(res?.data?.results);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    if (selectedServicecenter) {
      getData();
    }
  }, [selectedServicecenter, selectdeYear]);

  const monthlyData = data?.monthly_totals || [];

  const series = [
    {
      name: "Revenue",
      data: monthlyData.map((m) => m.total_billings),
    },
    {
      name: "Expense",
      data: monthlyData.map((m) => m.total_expenses),
    },
  ];

  const options = {
    chart: {
      type: "area",
      height: 320,
      width: "100%",
      toolbar: { show: false },
    },
    colors: ["#28a745", "#dc3545"],
    dataLabels: { enabled: false },
    stroke: { curve: "smooth", width: 2 },
    xaxis: {
      categories: monthlyData.map((m) => m.month_name.slice(0, 3)), // Jan, Feb...
      labels: { show: true },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      labels: { show: true },
    },
    tooltip: {
      theme: "dark",
      y: {
        formatter: (val) => `₹${formatToIndianNumber(val)}`,
      },
    },
    legend: {
      position: "bottom",
      horizontalAlign: "center",
      markers: { radius: 12 },
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 0.5,
        opacityFrom: 0.4,
        opacityTo: 0.1,
        stops: [0, 100],
      },
    },
    grid: { borderColor: "#f1f1f1" },
  };

  return (
    <div className="card shadow-sm border-0">
      <div className="pt-3 px-3 d-flex justify-content-between align-items-center gap-2 flex-wrap">
        <div className="d-flex gap-1">
          <h5>Revenue vs Expense</h5>
        </div>
        <GlobalSearchableDropdown
          isClearable={false}
          options={yearOption}
          selected={selectdeYear}
          onSelect={(item) => setSelectedYear(item)}
          placeholder="Year"
        />
      </div>
      <div className="p-1">
        <ReactApexChart
          options={options}
          series={series}
          type="area"
          height={320}
        />
      </div>
    </div>
  );
};

export default ProfitLossLineChart;
